import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import {
  ROOM_MODE_OPTIONS,
  type TYPE_DESIRED_COLOR_OPTIONS,
  type TYPE_DESIRED_STYLE_OPTIONS,
  type TYPE_MATERIAL_OPTIONS,
  type TYPE_ROOM_MODE_OPTIONS,
  type TYPE_ROOM_TYPE_OPTIONS,
} from '../constants/style-settings';

type RenderImageOptions = {
  mutationConfig?: MutationConfig<typeof renderImage>;
};

type RenderImageType = {
  image: File;
  roomtype: TYPE_ROOM_TYPE_OPTIONS;
  style: TYPE_DESIRED_STYLE_OPTIONS;
  colors?: TYPE_DESIRED_COLOR_OPTIONS[];
  materials?: TYPE_MATERIAL_OPTIONS[];
  mode: TYPE_ROOM_MODE_OPTIONS;
};

const modesWithRequiredFields = [
  ROOM_MODE_OPTIONS.CHANGE_FLOOR,
  ROOM_MODE_OPTIONS.CHANGE_STYLE,
  ROOM_MODE_OPTIONS.FURNITURE_REMOVAL,
  ROOM_MODE_OPTIONS.FURNISH_EMPTY_ROOM,
];

const renderImage = async ({
  image,
  roomtype,
  style,
  colors = [],
  materials = [],
  mode = 'changeStyle',
}: RenderImageType) => {
  // @ts-expect-error: TS can't infer mode correctly here
  if (modesWithRequiredFields.includes(mode) && (!roomtype || !style)) {
    throw Error('roomtype and style required for this mode');
  }

  return extractData(
    api['image-rendering'].post({
      image,
      roomtype,
      style,
      colors: colors.join(','),
      materials: materials.join(','),
      mode,
      // type inference also not working correctly here
    } as Parameters<(typeof api)['image-rendering']['post']>[0])
  );
};

export const useRenderImage = ({ mutationConfig }: RenderImageOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: renderImage,
  });
};
